import * as React from 'react';
import AppFooter from '../modules/views/AppFooter';
import CtaBand from '../modules/views/CtaBand';
import NavBar from '../modules/views/NavBar';
import withRoot from '../modules/withRoot';
import CaseCards from '../modules/views/CaseCards';
import { CARDS_NEW } from '../Const';
import PageMeta from '../modules/components/PageMeta';

function Index() {
  return (
    <React.Fragment>
      <PageMeta
        title="新築の施工事例"
        description="飯田建築の新築住宅・アパートの施工事例。建築士と一緒につくる、暮らしに合わせた住まいの実績を写真でご紹介します。"
        path="/case/new"
      />
      <NavBar />
      <CaseCards
        title={'新築'}
        eyebrow="New"
        cards={CARDS_NEW}
        animation={'animate__animated animate__fadeInUp'}
        backHref="/case"
      />
      <CtaBand />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
